export default {
  name: 'Retail Sale',
  slug: 'retail-sale',
  enabled: true,
  apiPrefix: '/api/modules/retail-sales',
  basePath: '/admin/module/retail-sale',
  storeNamespace: 'retailSale'
}
